module.exports = __webpack_public_path__ + "static/media/question.ecd1fe4e.svg";